/**
 * ContentMask component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Content mask (dark fade).
 */
const ContentMask = styled.div`
  background: linear-gradient(179deg, rgba(0, 0, 0, 0) 42.28%, #000 64.26%);
  bottom: 0;
  height: ${1080 * Screen.widthRatio}px;
  left: 0;
  position: absolute;
  width: ${1920 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(ContentMask);
